import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { VcardMatch, Alignment, Resume, Comments, Players, ROOT, ALIGNMENTS, RESUME, COMMENTS, PLAYERS } from '../index';
import '../styles/routes.scss';

interface IRoutesMatchesProps { }

export default class RoutesMatches extends Component<IRoutesMatchesProps> {
    constructor(props: IRoutesMatchesProps) {
        super(props);
    }
    render() {
        return (
            <div id="scroll">
                <Route path={`${ROOT}`} component={VcardMatch} />
                <Route path={`*/${ALIGNMENTS}`} component={Alignment} />
                <Route path={`*/${RESUME}`} component={Resume} />
                <Route path={`*/${COMMENTS}`} component={Comments} />
                <Route path={`*/${PLAYERS}`} component={() => <Players {...this.props} />} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/routes/RoutesMatches.tsx